module.exports = __webpack_public_path__ + "static/img/s7.2d03616.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s7.png
// module id = PeVP
// module chunks = 0